module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_rehoboth_m.c6bb0d37a532167dfbf6c2ee297abfa7.png";